/**
 * Seeded RNG shared with api/ft_generate.php (numeric LCG, 32-bit).
 * Daily seed string: `${dateISO}|${grade}|fact-trail-v1`
 */

export function fnv1a(str: string): number {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

export class Rng {
  s: number;
  constructor(seed: number | string) {
    this.s = typeof seed === "string" ? fnv1a(seed) : seed >>> 0;
    if (this.s === 0) this.s = 1;
  }
  /** [0, 1) */
  next(): number {
    this.s = (Math.imul(this.s, 1664525) + 1013904223) >>> 0;
    return this.s / 4294967296;
  }
  int(n: number): number {
    if (n <= 0) return 0;
    return Math.floor(this.next() * n);
  }
  intInc(lo: number, hi: number): number {
    return lo + this.int(hi - lo + 1);
  }
  pick<T>(arr: T[]): T {
    return arr[this.int(arr.length)];
  }
  shuffle<T>(arr: T[]): T[] {
    const a = arr.slice();
    for (let i = a.length - 1; i > 0; i--) {
      const j = this.int(i + 1);
      const t = a[i];
      a[i] = a[j];
      a[j] = t;
    }
    return a;
  }
  chance(p: number): boolean {
    return this.next() < p;
  }
}

export function dailySeedString(dateISO: string, grade: number): string {
  return `${dateISO}|${grade}|fact-trail-v1`;
}

export function utcDateISO(d = new Date()): string {
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, "0");
  const day = String(d.getUTCDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
